import React from 'react'
import AdminMonitoring from '@views/adminMonitoring/AdminMonitoring'

const ClientRoute = ({ userRoles, children }) => {
  const isAdmin = () => {
    return userRoles.some(role => role.indexOf('ADMIN') > -1)
  }

  if (isAdmin()) {
    return <AdminMonitoring/>
  }

  return children
}

export default ClientRoute
